<template>
  <v-card>
    <v-card-title>
      Extrato
      <div>
        <v-select
          style="margin: 30px 50px 0 100px;width:300px;"
          v-model="promotionUserId"
          :items="promotionUserList"
          item-text="name"
          item-value="id"
          label="Período"
          @change="getRecurringBalanceByPromotionUserId"
          required
        ></v-select>
      </div>
      <div>
        <v-text-field
          style="margin-top: 29px;min-width: 450px;"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
        ></v-text-field>
      </div>
    </v-card-title>
    <v-data-table :headers="headers" :items="recurringBalance" :search="search">
      <template v-slot:item="{ item }">
        <tr
          v-if="
            (item.type == 'reserva' &&
              (item.vehicle_request.step.code == 'cancel' ||
                item.vehicle_request.step.code == 'auto-cancel' ||
                item.vehicle_request.step.code == 'cancel-before-deadline')) ||
              (item.type == 'reserva' &&
                item.vehicle_request.step.code == 'complete')
          "
          :class="{
            'red lighten-4':
              item.vehicle_request.step.code == 'cancel' ||
              item.vehicle_request.step.code == 'auto-cancel' ||
              item.vehicle_request.step.code == 'cancel-before-deadline',
          }"
        >
          <td>
            {{ item.created_at | formatDate }}
          </td>
          <td>{{ item.vehicle_request.step.title }}</td>
          <td>Reserva</td>
          <td>-{{ item.value_minutes | validateSaldo }}</td>
          <td
            v-if="
              item.vehicle_request.step.code == 'cancel' ||
                item.vehicle_request.step.code == 'auto-cancel' ||
                item.vehicle_request.step.code == 'cancel-before-deadline'
            "
          >
            {{ (item.valueAcc - item.value_minutes) | validateSaldo }}
          </td>
          <td v-if="item.vehicle_request.step.title == 'Concluído'">
            {{ item.valueAcc | validateSaldo }}
          </td>
          <td class>
            {{ item.vehicle_request_id }}
            <v-icon small @click="abrirReserva(item)" color="info">
              open_in_new
            </v-icon>
          </td>
        </tr>
        <!--Caso haja extensão-->
        <tr v-if="item.type == 'extensao'">
          <td class>{{ item.updated_at | formatDate }}</td>
          <td class>{{ item.vehicle_request.step.title }}</td>
          <td class>Extensão da reserva</td>
          <td>-{{ item.value_minutes | validateSaldo }}</td>
          <td>
            {{ item.valueAcc | validateSaldo }}
          </td>
          <td class>
            {{ item.vehicle_request_id }}
            <v-icon small @click="abrirReserva(item)" color="info">
              open_in_new
            </v-icon>
          </td>
        </tr>
        <!--Reserva em checkin ou checkout-->
        <tr
          v-if="
            item.type == 'reserva' &&
              (item.vehicle_request.step.code == 'check-in' ||
                item.vehicle_request.step.code == 'check-out')
          "
        >
          <td>
            {{ item.created_at | formatDate }}
          </td>
          <td>{{ item.vehicle_request.step.title }}</td>
          <td>Reserva</td>
          <td>-{{ item.value_minutes | validateSaldo }}</td>
          <td>
            {{ item.valueAcc | validateSaldo }}
          </td>
          <td class>
            {{ item.vehicle_request_id }}
            <v-icon small @click="abrirReserva(item)" color="info">
              open_in_new
            </v-icon>
          </td>
        </tr>

        <!--Data cancelamento reserva-->
        <tr
          v-if="
            item.type == 'reserva' &&
              (item.vehicle_request.step.code == 'cancel' ||
                item.vehicle_request.step.code == 'auto-cancel' ||
                item.vehicle_request.step.code == 'cancel-before-deadline')
          "
          class="red lighten-4"
        >
          <td>
            {{ item.vehicle_request.cancel_date | formatDate }}
          </td>
          <td>{{ item.vehicle_request.step.title }}</td>
          <td>Reserva</td>
          <td>+{{ item.value_minutes | validateSaldo }}</td>
          <td>
            {{ item.valueAcc | validateSaldo }}
          </td>
          <td class>
            {{ item.vehicle_request_id }}
            <v-icon small @click="abrirReserva(item)" color="info">
              open_in_new
            </v-icon>
          </td>
        </tr>
        <!--Abastecimentos-->
        <tr v-if="item.type == 'abastecimento'">
          <td class>{{ item.updated_at | formatDate }}</td>
          <td>Adicionados 30 min</td>
          <td class>Abastecimento</td>
          <td>
            {{ `+${item.value_minutes}min` }}
          </td>
          <td>{{ item.valueAcc | validateSaldo }}</td>
          <td>
            {{ item.vehicle_request_id }}
            <v-icon small @click="abrirReserva(item)" color="info">
              open_in_new
            </v-icon>
          </td>
        </tr>
        <!--Depósitos (renovação do plano)-->
        <tr
          v-if="item.type == 'deposito'"
          :class="{ 'blue lighten-4': item.type == 'deposito' }"
        >
          <td class>{{ item.updated_at | formatDate }}</td>
          <td></td>
          <td class>Depósito</td>
          <td>+{{ item.value_minutes | validateSaldo }}</td>
          <td>{{ item.value_minutes | validateSaldo }}</td>
          <td></td>
        </tr>
      </template>
      <template v-slot:body.append>
        <tr>
          <td>Saldo(Hr): {{ saldo | validateSaldo }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import moment from 'moment';
import CobrancasRecorrentesController from '../../controllers/CobrancasRecorrentesController';
import PromotionUserController from '../../controllers/PromotionUserController';
import DateHelper from '../../helpers/DateHelper';

export default {
  created() {
    this.getCurrentPromotionUser();
    this.getReservations();
  },

  data() {
    return {
      cobrancasRecorrentesController: new CobrancasRecorrentesController(
        this.$resource
      ),
      promotionUserController: new PromotionUserController(this.$resource),
      currentPromotionUser: null,
      promotionUserList: [],
      promotionUserId: this.$route.params.promotion_user_id,
      search: '',
      recurringBalance: [],
      depositos: 0,
      headers: [
        { text: 'Data da transação', value: 'updated_at' },
        { text: 'Status', value: 'title' },
        { text: 'Tipo', value: 'type' },
        { text: 'Valor em horas', value: 'value_minutes' },
        { text: 'Saldo(hrs)', value: 'saldoAtualizado' },
        { text: 'Id', value: 'vehicle_request_id' },
      ],
      saldo: 0,
    };
  },

  methods: {
    getCurrentPromotionUser() {
      this.promotionUserController.getById(this.promotionUserId).then(res => {
        this.currentPromotionUser = res.body;
        this.getPromotionsUserByPromotionIdAndUserId(
          this.currentPromotionUser.promotion_id,
          this.currentPromotionUser.user_id
        );
      });
    },
    getRecurringBalanceByPromotionUserId() {
      this.getReservations(this.promotionUserId);
    },
    getPromotionsUserByPromotionIdAndUserId(promotionId, userId) {
      this.promotionUserController
        .getPromotionsUserByPromotionIdAndUserId(promotionId, userId)
        .then(res => {
          res.map(promotionUser => {
            this.promotionUserList.push({
              name: `De ${DateHelper.formatDate(
                promotionUser.activation_date
              )} a ${DateHelper.formatDate(promotionUser.expiration_date)}`,
              id: promotionUser.id,
            });
          });
        })
        .catch(e => {
          console.log(e);
          throw e;
        });
    },
    getReservations() {
      this.cobrancasRecorrentesController
        .recurringBalance(this.promotionUserId)
        .then(res => {
          this.recurringBalance = res.data;
          this.depositos = res.depositos;
          this.saldo = res.saldo;
          this.atualizaSaldo(this.recurringBalance);
          console.log(res.data);
        });
    },

    atualizaSaldo(recurringBalanceList) {
      recurringBalanceList.forEach(item => {
        if (item.vehicle_request_id === null) {
          return;
        }
        let valueAcc;

        if (
          item.type == 'reserva' &&
          (item.vehicle_request.step.code == 'check-in' ||
            item.vehicle_request.step.code == 'check-out' ||
            item.vehicle_request.step.code == 'complete')
        ) {
          valueAcc = this.depositos - item.value_minutes;
        } else if (
          item.type == 'reserva' &&
          (item.vehicle_request.step.code == 'cancel' ||
            item.vehicle_request.step.code == 'auto-cancel' ||
            item.vehicle_request.step.code == 'cancel-before-deadline')
        ) {
          valueAcc = this.depositos;
        } else if (item.type == 'abastecimento' || item.type == 'deposito') {
          valueAcc = this.depositos + item.value_minutes;
        } else if (item.type == 'extensao') {
          valueAcc = this.depositos - item.value_minutes;
        }
        this.depositos = valueAcc;
        item.valueAcc = valueAcc;
        console.log(item.valueAcc);
      });
    },

    abrirReserva(item) {
      let routeData = this.$router.resolve(
        '/tcs/reserva/' + item.vehicle_request_id
      );
      window.open(routeData.href, '_blank');
    },
  },
  filters: {
    timeDecimal(value) {
      return value ? (value > 9 ? value : `0${value}`) : '00';
    },

    formatDate(value) {
      return value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : '';
    },

    metersToKm(value) {
      return value ? (value / 100).toFixed(2).replace('.', ',') : '0,00';
    },

    validateSaldo(saldo) {
      if (saldo <= 0) return '00:00';
      let min = saldo % 60;
      let hr = Math.floor(saldo / 60);

      if (min < 10) min = `0${min}`;
      if (hr < 10) hr = `0${hr}`;
      if (hr <= 0) hr = '00';

      return `${hr}h:${min}m`;
    },
  },
};
</script>
